import React, { useEffect, useState } from "react";
import './style.css';
import { Layout, Spin, Breadcrumb, Table, Button, Input, Row, Col, Divider, DatePicker, Tabs, List, Avatar } from 'antd';
import { SyncOutlined } from '@ant-design/icons';
import { Link, useHistory, useLocation } from "react-router-dom";
import Container from '../../Layout/Container';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { useSelector, useDispatch } from 'react-redux';
import { getAllNotification, resendNotification, DDsAndAdsViewProcessSelector, clearState, takeActionChildProcessAsyn, clearStateResendNotify } from './DDsAndAdsViewAllNotificationSlice';
import moment from 'moment';
const { TabPane } = Tabs;
const { Header, Content, Footer } = Layout;
const { Search } = Input;
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;

const recived = [
  {
    id: 1,
    title: 'Recived item lorem ispum dor sit amet 1',
    time: '04:34 PM',
    discription: 'Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet.Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet.',
  }
];

const sent = [
  {
    id: 1,
    title: 'Recived item lorem ispum dor sit amet 1',
    time: '04:34 PM',
    discription: 'Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet.Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet.',
  }
];

export default function ClerkNotification() {
  const dispatch = useDispatch();
  let history = useHistory();
  const location = useLocation();
  const [isLoading, setLoading] = React.useState(false);
  const [isToast, setToast] = React.useState(false);
  const [todayDataSource, settodayDataSource] = useState([]);
  const [yesterdayDataSource, setyesterdayDataSource] = useState([])
  const [notificationType, setnotificationType] = useState('received');

  const { isFetching, isNotifySuccess, isResendNotySucess, isError, errorMessage, NotifyData, imagePath } = useSelector(
    DDsAndAdsViewProcessSelector
  );


  useEffect(() => {
    setLoading(true);
    setToast(false);
    dispatch(clearState());
    dispatch(clearStateResendNotify());
    dispatch(getAllNotification(notificationType));
  }, []);

  useEffect(() => {

    if (isError) {
      setLoading(false);
      setToast(true);
      toast.error(errorMessage);
      dispatch(clearStateResendNotify());
    }
    if (isResendNotySucess) {
      setLoading(false);
      setToast(true);
      toast.success(errorMessage);
      dispatch(clearStateResendNotify());
    }

    if (isNotifySuccess) {
      let yesterdayData = [];
      let todayData = [];
      setLoading(false);
      // setTimeout(() => {

      //   if (NotifyData) {
      //     NotifyData.map(row => {

      //       // console.log("back => " + moment(row.created_at).format('YYYY-MM-DD'));
      //       // console.log("Today => " + moment().add(-1, 'days').format('YYYY-MM-DD'));

      //       //......... For Todays records..........

      //       if (moment(row.created_at).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')) {

      //         todayData.push({
      //           id: row.uuid,
      //           imgName: row && row.userDetail && row.userDetail.profilePic != null ? imagePath + row.userDetail.profilePic : './default-View-SubAdmin-Img.png',
      //           // title: notificationType === 'sent' ? row.receiver_username : row.sender_username,
      //           title: row.userDetail.fullName,
      //           time: moment(row.created_at).format("hh:mm A"),
      //           discription: row.message,
      //         });

      //       }

      //       //......... For yesterday records..........

      //       if (moment(row.created_at).format('YYYY-MM-DD') === moment().add(-1, 'days').format('YYYY-MM-DD')) {

      //         yesterdayData.push({

      //           id: row.uuid,
      //           imgName: row && row.userDetail && row.userDetail.profilePic != null ? imagePath + row.userDetail.profilePic : './default-View-SubAdmin-Img.png',
      //           //title: notificationType === 'sent' ? row.receiver_username : row.sender_username,
      //           title: row.userDetail.fullName,
      //           time: moment(row.created_at).format("hh:mm A"),
      //           discription: row.message,
      //         });

      //       }

      //     });

      //     settodayDataSource(todayData);
      //     setyesterdayDataSource(yesterdayData);
      //   }


      //   setLoading(false);
      // }, 1000);
    }

  }, [isError, isNotifySuccess, isResendNotySucess, setLoading, NotifyData, imagePath]);


  const create_human_friendly_date = (
    timestamp,
    yesterday_text,
    today_text,
    tomorrow_text,
    language
  ) => {
    var in_the_last_7days_date_options = { weekday: 'long' };
    var in_the_next_7days_date_options = { month: 'short', day: 'numeric' };
    var same_year_date_options = { month: 'short', day: 'numeric' };
    var far_date_options = { year: 'numeric', month: 'short', day: 'numeric' };

    var dt = new Date(timestamp);
    var date = dt.getDate();
    var time_diff = timestamp - Date.now();
    var diff_days = new Date().getDate() - date;
    var diff_months = new Date().getMonth() - dt.getMonth();
    var diff_years = new Date().getFullYear() - dt.getFullYear();

    var is_today = diff_years === 0 && diff_months === 0 && diff_days === 0;
    var is_yesterday = diff_years === 0 && diff_months === 0 && diff_days === 1;
    var is_tomorrow = diff_years === 0 && diff_months === 0 && diff_days === -1;
    var is_in_the_last_7days = diff_years === 0 && diff_months === 0 && (diff_days > 1 && diff_days < 7);
    var is_in_the_next_7days = diff_years === 0 && diff_months === 0 && (diff_days < -1 && diff_days > -7);
    var is_same_year = diff_years === 0;

    if (is_today) {
      return today_text;
    } else if (is_yesterday) {
      return yesterday_text;
    } else if (is_tomorrow) {
      return tomorrow_text;
    } else if (is_in_the_last_7days) {
      return dt.toLocaleString(language, in_the_last_7days_date_options);
    } else if (is_in_the_next_7days) {
      return dt.toLocaleString(language, in_the_next_7days_date_options);
    } else if (is_same_year) {
      return dt.toLocaleString(language, same_year_date_options);
    } else {
      return dt.toLocaleString(language, far_date_options);
    }
  }


  // console.log(create_human_friendly_date(Date.now(), "Yesterday", "Today", "Tomorrow", "en")); 

  const getTakeActiondata = (e, values) => {

    e.preventDefault();
    if (values.childProcess === true) {

      let takeActionChildProcess = dispatch(takeActionChildProcessAsyn(values.documentDetail.processId)).then((res) => {
        // console.log("res =>", res);
        history.push({
          pathname: '/verify-document2',
          state: { documentInfo: res.data, processId: res.data.documentUpdatedData.processId, viewDocument: true, }
        });

      });
    }
    else {
      history.push({
        pathname: '/take-action-notification',
        state: { processId: values.documentDetail.processId }
      });
    }

  };

  const getResenddata = (e, values) => {
    // console.log(values)
    e.preventDefault();
    var data = {
      "uuid": values.uuid
    }
    dispatch(resendNotification(data));
  };

  function callback(key) {
    setnotificationType('');
    setnotificationType(key);
    localStorage.setItem('notificationTab', key);
    dispatch(getAllNotification(key));
  }

  // let todayDataSource = NotifyData ? NotifyData.map(row => {

  //   // console.log("back => " + moment(row.created_at).format('YYYY-MM-DD'));
  //   // console.log("Today => " + moment().add(-1, 'days').format('YYYY-MM-DD'));

  //   if (moment(row.created_at).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')) {

  //     // row.map((current, index) => ({

  //     return {

  //       id: row.uuid,
  //       imgName: row && row.userDetail[0] && row.userDetail[0].profilePic != null ? imagePath + row.userDetail[0].profilePic : './default-View-SubAdmin-Img.png',
  //       title: row.receiver_username,
  //       time: moment(row.created_at).format("hh:mm A"),
  //       discription: row.message,

  //       // })
  //       // )

  //     }
  //   }

  // }) : [];

  let sentCount = -1;
  return (
    <>
      <Container>

        <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%' }} spinning={isLoading} />
        <Breadcrumb style={{ margin: '16px 48px ' }} separator=">">
          <Breadcrumb.Item><Link to="/dashboard">Dashboard</Link></Breadcrumb.Item>
          <Breadcrumb.Item>Notification</Breadcrumb.Item>
        </Breadcrumb>
        {isToast &&
          <Toaster
            toastOptions={{
              className: '',
              style: {
                border: '1px solid #713200',
                padding: '16px',
                color: '#713200',
                marginTop: 50
              },
            }}
          >
            {(t) => (
              <ToastBar toast={t}>
                {({ icon, message }) => (
                  <>
                    {icon}
                    {message}
                    {t.type !== 'loading' && (
                      <button onClick={() => toast.dismiss(t.id)}>X</button>
                    )}
                  </>
                )}
              </ToastBar>
            )}
          </Toaster>
        }
        <Row style={{ margin: '16px 48px 48px 48px ' }}>
          <Col span={24} style={{ border: "1px solid #e3e5ee", borderRadius: '5px', backgroundColor: '#ffffff' }} className="clerk-dashboard-tab-sec">
            <Tabs defaultActiveKey="1" onChange={callback} className="notification-page-tabs">
              <TabPane tab="Received" key="received">
                <div style={{ padding: '8px 20px 10px 20px' }}>
                  <List
                    itemLayout="horizontal"
                    dataSource={NotifyData && NotifyData.slice().reverse()}
                    renderItem={item => {
                      let imgName = item.userDetail && item.userDetail.profilePic != null ? imagePath + item.userDetail.profilePic : './default-View-SubAdmin-Img.png';
                      let title = item.sender_username;
                      let time = moment(item.created_at).format("hh:mm A");
                      let discription = item.message;
                      // var start = moment("2013-11-03").format("YYYY-mm-dd");
                      var start = moment(item.created_at);
                      var end = moment();
                      let noOfDays = end.diff(start, "days");
                      let headerTitle = create_human_friendly_date(Date.now() - (1000 * 3600 * 24 * noOfDays), "Yesterday", "Today", "Tomorrow", "en");
                      // let filteredDates = NotifyData.filter(d => d.created_at === item.created_at);
                      // console.log('filteredDates',filteredDates)
                      let showButton = false;
                      let showStatus = '';
                      let showMsg = '';

                      if (item && item.documentDetail && item.documentDetail.status) {

                        if (item.documentDetail.status === "filed") {
                          showStatus = "DDsAndAds-notyStatus-filed";
                          showButton = true;
                          showMsg = "filed";
                        }
                        else if (item.documentDetail.status === "reject") {
                          showStatus = "DDsAndAds-notyStatus-reject";
                          showButton = true;
                          showMsg = "reject";
                        }
                      }
                      if (item && item.documentDetail && item.documentDetail.signed && item.documentDetail.signed.length > 0) {

                        if (item.documentDetail.signed[0].isSigned === true) {
                          showStatus = "DDsAndAds-notyStatus-signed";
                          showButton = true;
                          showMsg = "signed";
                        }
                      }

                      let headerShow = false;
                      if (sentCount != noOfDays) {
                        headerShow = true;
                        sentCount = noOfDays;
                      }
                      return (
                        <>
                          {headerShow &&
                            <h2 className="tab-title-custom">{headerTitle.toUpperCase()}</h2>
                          }

                          <List.Item key={item.id} actions={showButton === false ? [<Button className="notification-take-action-btn" type={'primary'} size={'middle'} onClick={(e) => getTakeActiondata(e, item)} >Take Action</Button>] : [<span className={showStatus}>{showMsg}</span>]}>
                            <List.Item.Meta
                              avatar={<Avatar src={imgName} />}
                              title={
                                <>
                                  <span className="title">{title}</span>
                                  <span className="time">{time}</span>
                                </>
                              }
                              description={discription}
                            />
                          </List.Item>
                        </>
                      )
                    }}
                  />
                  <div style={{ marginTop: 30 }}></div>
                  {/* <h2 className="tab-title-custom">TODAY</h2>
                  <List
                    itemLayout="horizontal"
                    dataSource={todayDataSource}
                    renderItem={item => (
                      <List.Item key={item.id} actions={[<Button type={'primary'} size={'middle'} onClick={(e) => getTakeActiondata(e, item)} >Take Action</Button>]}>
                        <List.Item.Meta
                          avatar={<Avatar src={item.imgName} />}
                          title={
                            <>
                              <span className="title">{item.title}</span>
                              <span className="time">{item.time}</span>
                            </>
                          }
                          description={item.discription}
                        />
                      </List.Item>
                    )}
                  />

                  <h2 className="tab-title-custom" style={{ marginTop: '30px' }}>YESTERDAY</h2>
                  <List
                    itemLayout="horizontal"
                    dataSource={yesterdayDataSource}
                    renderItem={item => (
                      <List.Item key={item.id} actions={[<Button type={'primary'} size={'middle'} onClick={(e) => getTakeActiondata(e, item)} >Take Action</Button>]}>
                        <List.Item.Meta
                          avatar={<Avatar src={item.imgName} />}
                          title={
                            <>
                              <span className="title">{item.title}</span>
                              <span className="time">{item.time}</span>
                            </>
                          }
                          description={item.discription}
                        />
                      </List.Item>
                    )}
                  /> */}

                </div>
              </TabPane>
              <TabPane tab="Sent" key="sent">
                <div style={{ padding: '8px 20px 10px 20px' }}>
                  <List
                    itemLayout="horizontal"
                    dataSource={NotifyData && NotifyData.slice().reverse()}
                    renderItem={item => {
                      let imgName = item.userDetail && item.userDetail.profilePic != null ? imagePath + item.userDetail.profilePic : './default-View-SubAdmin-Img.png';
                      let title = item.sender_username;
                      let time = moment(item.created_at).format("hh:mm A");
                      let discription = item.message;
                      // var start = moment("2013-11-03").format("YYYY-mm-dd");
                      var start = moment(item.created_at);
                      var end = moment();
                      let noOfDays = end.diff(start, "days");
                      let headerTitle = create_human_friendly_date(Date.now() - (1000 * 3600 * 24 * noOfDays), "Yesterday", "Today", "Tomorrow", "en");
                      // let filteredDates = NotifyData.filter(d => d.created_at === item.created_at);
                      // console.log('filteredDates',filteredDates)
                      let showButton = false;
                      let showStatus = '';
                      let showMsg = '';

                      if (item && item.documentDetail && item.documentDetail.status) {

                        if (item.documentDetail.status === "filed") {
                          showStatus = "DDsAndAds-notyStatus-filed";
                          showButton = true;
                          showMsg = "filed";
                        }
                        else if (item.documentDetail.status === "reject") {
                          showStatus = "DDsAndAds-notyStatus-reject";
                          showButton = true;
                          showMsg = "reject";
                        }
                      }
                      if (item && item.documentDetail && item.documentDetail.signed && item.documentDetail.signed.length > 0) {

                        if (item.documentDetail.signed[0].isSigned === true) {
                          showStatus = "DDsAndAds-notyStatus-signed";
                          showButton = true;
                          showMsg = "signed";
                        }
                      }
                      let headerShow = false;
                      if (sentCount != noOfDays) {
                        headerShow = true;
                        sentCount = noOfDays;
                      }
                      return (
                        <>
                          {headerShow &&
                            <h2 className="tab-title-custom">{headerTitle.toUpperCase()}</h2>
                          }

                          <List.Item key={item.id} actions={showButton === false ? [<Button className="notification-take-action-btn" type={'primary'} size={'middle'} onClick={(e) => getResenddata(e, item)} >Resend</Button>] : [<span className={showStatus}>{showMsg}</span>]}>
                            <List.Item.Meta
                              avatar={<Avatar src={imgName} />}
                              title={
                                <>
                                  <span className="title">{title}</span>
                                  <span className="time">{time}</span>
                                </>
                              }
                              description={discription}
                            />
                          </List.Item>
                        </>
                      )
                    }}
                  />
                  <div style={{ marginTop: 30 }}></div>
                  {/* <h2 className="tab-title-custom">TODAY</h2>
                  <List
                    itemLayout="horizontal"
                    dataSource={todayDataSource}
                    renderItem={item => (
                      <List.Item key={item.id} actions={[<Button type={'primary'} size={'middle'} onClick={(e) => getTakeActiondata(e, item)} >Resend</Button>]}>
                        <List.Item.Meta
                          avatar={<Avatar src={item.imgName} />}
                          title={
                            <>
                              <span className="title">{item.title}</span>
                              <span className="time">{item.time}</span>
                            </>
                          }
                          description={item.discription}
                        />
                      </List.Item>
                    )}
                  />

                  <h2 className="tab-title-custom" style={{ marginTop: '30px' }}>YESTERDAY</h2>
                  <List
                    itemLayout="horizontal"
                    dataSource={yesterdayDataSource}
                    renderItem={item => (
                      <List.Item key={item.id} actions={[<Button type={'primary'} size={'middle'} onClick={(e) => getTakeActiondata(e, item)} >Resend</Button>]}>
                        <List.Item.Meta
                          avatar={<Avatar src={item.imgName} />}
                          title={
                            <>
                              <span className="title">{item.title}</span>
                              <span className="time">{item.time}</span>
                            </>
                          }
                          description={item.discription}
                        />
                      </List.Item>
                    )}
                  /> */}

                </div>
              </TabPane>
            </Tabs>
          </Col>
        </Row>

      </Container>
    </>
  );
}
